/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	AnnouncementDTO,
	AnnouncementDTOFromJSON,
	AnnouncementDTOFromJSONTyped,
	AnnouncementDTOToJSON,
} from "./AnnouncementDTO";

/**
 *
 * @export
 * @interface AnnouncementDTOPagedResponse
 */
export interface AnnouncementDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof AnnouncementDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof AnnouncementDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof AnnouncementDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<AnnouncementDTO>}
	 * @memberof AnnouncementDTOPagedResponse
	 */
	data?: Array<AnnouncementDTO> | null;
}

export function AnnouncementDTOPagedResponseFromJSON(
	json: any
): AnnouncementDTOPagedResponse {
	return AnnouncementDTOPagedResponseFromJSONTyped(json, false);
}

export function AnnouncementDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AnnouncementDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(AnnouncementDTOFromJSON),
	};
}

export function AnnouncementDTOPagedResponseToJSON(
	value?: AnnouncementDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(AnnouncementDTOToJSON),
	};
}
